import { AppAnalytics, PopupOpened, PopupClosed } from '../../Analytics';
import { POPUP_NAME, PAGE_NAME } from '../../eventNames';

const popupOpenEvents = {
  showSharePopup: (popupContext = {}, pageName) => {
    const context = { ...popupContext };
    AppAnalytics.reportEvent(
      new PopupOpened(pageName, POPUP_NAME.SHOW_SHARE_ASSESSMENT_POP_UP, context)
    );
  },
  hideSharePopup: (popupContext = {}, pageName) => {
    const context = { ...popupContext };
    AppAnalytics.reportEvent(
      new PopupClosed(pageName, POPUP_NAME.HIDE_SHARE_ASSESSMENT_POP_UP, context)
    );
  },
  sendReportsPopup: (popupContext = {}, pageName) => {
    const context = { ...popupContext };
    AppAnalytics.reportEvent(new PopupClosed(pageName, POPUP_NAME.SEND_REPORTS_POPUP, context));
  },
  reportSendSuccessPopup: (popupContext = {}, pageName) => {
    const context = { ...popupContext };
    AppAnalytics.reportEvent(
      new PopupClosed(pageName, POPUP_NAME.SUCCESS_ON_GET_REPORTS_POPUP, context)
    );
  },
  reportSendErrorPopup: (popupContext = {}, pageName) => {
    const context = { ...popupContext };
    AppAnalytics.reportEvent(
      new PopupClosed(pageName, POPUP_NAME.ERROR_ON_GET_REPORTS_POPUP, context)
    );
  },
  showCSTPopup: (popupContext = {}, pageName) => {
    const context = { ...popupContext };
    AppAnalytics.reportEvent(new PopupClosed(pageName, POPUP_NAME.CST_POP_UP, context));
  },
};

export default popupOpenEvents;
